import { mapBedbankBoardCode } from 'api/mappers/bedbankRateMap'
import determineOfferFeatureSymbol from 'lib/offer/determineOfferFeatureSymbol'
import uuidV4 from 'lib/string/uuidV4Utils'

function mapEnquiryBedGroups(bedGroup: { id: string; description: string; configuration: Array<{ type: string; size: string; quantity: number }> }): App.RoomBedGroups {
  return {
    id: bedGroup.id,
    description: bedGroup.description,
    configuration: bedGroup.configuration.map(config => ({
      type: config.type,
      size: config.size,
      quantity: config.quantity,
    })),
  }
}

export function mapEnquiryRateFields(rate: NonNullable<App.EnquiryResponse['rate']>): Partial<App.BedbankEnquiry> {
  return {
    bedGroups: rate.bedGroups.map(mapEnquiryBedGroups),
    supplierCode: rate.supplierCode,
    supplier: rate.supplier,
    refundable: rate.refundable,
    partiallyRefundable: rate.partiallyRefundable,
    mobilePromotion: rate.mobilePromotion,
    corporate: rate.corporate,
    boardCode: mapBedbankBoardCode(rate.boardCode),
    promotionId: rate.promotionId ?? undefined,
    value: rate.value,
    discount: Math.floor(rate.discount * 100),
    memberDiscount: rate.luxPlusDiscount ? Math.floor(rate.luxPlusDiscount * 100) : 0,
    mx: rate.mx,
    nonRefundableDateRanges: rate.nonRefundableDateRanges,
    inclusions: rate.inclusions?.map(inclusion => ({
      id: uuidV4(),
      description: inclusion.text,
      symbol: determineOfferFeatureSymbol(inclusion.icon || inclusion.text),
    })) ?? [],
  }
}
